// Generated by ReScript, PLEASE EDIT WITH CARE


var user_city = "user_city";

export {
  user_city ,
}
/* No side effect */
